// let apiHost = 'http://gp.admin.pentaq.ltd/'
// noinspection HttpUrlsUsage

let apiHost = "https://cf.admin.pentaq.com/api/"
// let apiHost = "/localhost-api/"
// let apiHost = "/test-api/"

// if (location.host === 'cfhd.pentaq.ltd') {
//   apiHost = "http://cf.admin.pentaq.ltd/api/"
// }

let Api = {
  login: apiHost + 'user_api/login',
  get_a_nonce: apiHost + 'user_api/get_a_nonce',
  get_level: apiHost + 'user_api/user_check_auth',
  logout: apiHost + 'user_api/logout',

  //嵌套页面
  conventionalGame: apiHost + 'authApi/conventionalGame',
  getCFSGameOverData: apiHost + 'authApi/getCFSGameOverData',
  conventionalCfsyuxuanGame: apiHost + 'authApi/conventionalCFSYUxuanGame',

  // conventionalGame: apiHost + 'downData/dowmMatchData',

  conventionalEWCGame: apiHost + 'authApi/conventionalEWCGame',

  searchGameData: apiHost + 'authApi/searchGameData',
  getMatrixPlayerList: apiHost + 'authApi/getMatrixPlayerList',
  getMatrixPlayerAllMatchList: apiHost + 'authApi/getMatrixPlayerAllMatchList',
  // conventionalGame: 'http://cf.admin.pentaq.com/api/authApi/conventionalGame',
  // searchGameData: 'https://cfm.admin.pentaq.com/api/authApi/searchGameData',

  //裁判端
  judge_login: apiHost + 'judge/login',
  judge_check_login: apiHost + 'judge/check_login',

  judge_subcontest_player_list: apiHost + 'judge/subcontest_player_list',
  judge_contest_list: apiHost + 'judge/contest_list',
  judge_subcontest_list: apiHost + 'judge/subcontest_list',
  judge_subcontest_match_list: apiHost + 'judge/subcontest_match_list',
  judge_match_map_list: apiHost + 'judge/match_map_list',
  judge_round_list: apiHost + 'judge/round_list',
  judge_set_round_win_way: apiHost + 'judge/set_round_win_way',
  judge_score_subcontest: apiHost + 'judge/score_subcontest',
  judge_select_match_map: apiHost + 'select_match_map',

  judge_set_match_map_mvp: apiHost + 'judge/set_match_map_mvp',
  judge_set_subcontest_match_mvp: apiHost + 'judge/set_subcontest_match_mvp',
  judge_start_match_queue: apiHost + 'judge/start_match_queue',
  judge_set_contest_default: apiHost + 'judge/set_contest_default',

  judge_control_api: apiHost + 'judge/control_api',
  judge_map_list: apiHost + 'judge/map_list',
  judge_team_player_list: apiHost + 'judge/team_player_list',
  searchOBPlayerData: apiHost + 'authApi/searchOBPlayerData',

  // 里程碑
  getTeamData: apiHost + 'milepost/getTeamData',
  searchMilepostData: apiHost + 'milepost/searchMilepostData',

  getGameOverData: apiHost + 'authApi/getGameOverData',

  // 海报
  getWeaponData: apiHost + 'poster/getWeaponData',
  getPlayerData: apiHost + 'poster/getPlayerData',
  getPlayerGameData: apiHost + 'poster/getPlayerGameData',
  getBestPlayerData: apiHost + 'poster/getBestPlayerData', // 最佳选手
  getBestTeamData: apiHost + 'poster/getBestTeamData', // 最佳阵容
  getMatchList: apiHost + 'poster/getMatchList', // 最佳阵容
  getTeamGameData: apiHost + 'poster/getTeamGameData', // 队伍数据
  searchPosterTeamScoreData: apiHost + 'poster/searchPosterTeamScoreData', // 积分信息

  // getWeaponData: 'https://cfm.admin.pentaq.com/api/poster/getWeaponData',
  // getPlayerData: 'https://cfm.admin.pentaq.com/api/poster/getPlayerData',
  // getPlayerGameData: 'https://cfm.admin.pentaq.com/api/poster/getPlayerGameData',
  // getBestPlayerData: 'https://cfm.admin.pentaq.com/api/poster/getBestPlayerData', // 最佳选手
  // getBestTeamData: 'https://cfm.admin.pentaq.com/api/poster/getBestTeamData', // 最佳阵容

  uploadCityGameData: apiHost + 'UploadExcel/uploadCityGameData', // 上传文件

  // cfpl_tool的里程碑
  getPlayerRankData: apiHost + 'milestone/getPlayerRankData',   // 选手里程碑排行
  saveMileThrshdData: apiHost + 'milestone/saveMileThrshdData',  // 设置里程碑阈值
  searchMileThrshdData: apiHost + 'milestone/searchMileThrshdData',  // 查询阈值
  getMilestByTeamORPlayer: apiHost + 'milestone/getMilestByTeamORPlayer', // 选手里程碑数据
  searchMileTeamData: apiHost + 'milestone/searchMileTeamData',  // 战队数据
  downPlayerMileData: apiHost + 'milestone/downPlayerMileData',  // 下载战队数据

  //数据矩阵
  getmatchList: apiHost + 'matrixData/getmatchList',  //
  getplayerData: apiHost + 'matrixData/getplayerData',  //
  getteamData: apiHost + 'matrixData/getteamData',  //


  // 直转播工具
  VSPOteamData: apiHost + 'vspo/VSPOteamData',  // 队伍列表
  delVSPOData: apiHost + 'vspo/delVSPOData',  // 重置数据
  saveVSPOData: apiHost + 'vspo/saveVSPOData',  // 保存数据
  searchVSPOData: apiHost + 'vspo/searchVSPOData', // 查询已保存数据
}

export {Api}



// WEBPACK FOOTER //
// ./src/api/config.js